import { Component, OnInit } from '@angular/core';
import { Car } from 'src/app/models/car.model';
import { CarService } from 'src/app/service/http-services/car.service';

@Component({
  selector: 'app-car',
  templateUrl: './car.component.html',
  styleUrls: ['./car.component.css']
})
export class CarComponent implements OnInit {

  cars: Car[] = [];

  headElements = ['Brand', 'Name', ""];

  constructor(
    private carService: CarService
  ) { }

  ngOnInit(): void {
    this.carService.getCars().subscribe(
      response => this.handleSuccessfulResponse(response),
    );
  }

  deleteCar(car: Car) {
    this.carService.deleteCar(car)
      .subscribe(() => {
        this.cars = this.cars.filter(u => u != car);
      })
  }

  handleSuccessfulResponse(response: Car[]) {
    this.cars = response
  }


}
